export default function formatCurrency(value){
    return parseFloat(value).toLocaleString('pt-BR', {
        currency: 'BRL',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      })
}